import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFullPodcast } from "@store/action/planning/PodcastAction";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FilterBlog from "./Filter";
import Podcast from "./Podcast";
import "@styles/base/pages/app-ecommerce.scss";

const getPodcastList = () => {
  const radio_id = localStorage.getItem("radio_id");
  // ** States
  const [activeView, setActiveView] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  // ** Vars
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const store = useSelector((state) => state.podcastReducer);

  useEffect(() => {
    dispatch(
      getFullPodcast({
        page: currentPage,
        per_page: 5,
        search: window.location.search,
      })
    );
    return () => {
      dispatch({
        type: "EMPTY_GET_FULL_PODCASTS",
      });
    };
  }, [dispatch, window.location.search]);

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Podcast")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Podcast")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-part">
        <div className="container__video">
          <div className="row content-reverse">
            <FilterBlog
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={setCurrentPage}
            />
            <div className="ecommerce-application col-lg-9">
              <Podcast
                activeView={activeView}
                setActiveView={setActiveView}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                getFullPodcast={getFullPodcast}
                dispatch={dispatch}
                radio_id={radio_id}
                store={store}
                t={t}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default getPodcastList;
